import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react'

// Get projectId from https://cloud.walletconnect.com
const projectId = "0b8444fa79de9a3821c5410564de263f";

// Configure chains
const mainnet = {
    chainId: 1,
    name: 'Ethereum',
    currency: 'ETH',
    explorerUrl: 'https://etherscan.io',
    rpcUrl: 'https://cloudflare-eth.com'
}

const bsc = {
    chainId: 56,
    name: 'Binance Smart Chain',
    currency: 'BNB',
    explorerUrl: 'https://bscscan.com',
    rpcUrl: 'https://bsc-dataseed.binance.org/'
}

const bscTestnet = {
    chainId: 97,
    name: 'BNB Smart Chain Testnet',
    currency: 'tBNB',
    explorerUrl: 'https://testnet.bscscan.com',
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/'
}

// Metadata
const metadata = {
    name: 'RWA Tokenization Platform',
    description: 'Real World Asset Tokenization Platform',
    url: window.location.origin,
    icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// Create Ethers config
const ethersConfig = defaultConfig({
    metadata,
    enableEIP6963: true,
    enableInjected: true,
    enableCoinbase: true,
})

// Create Web3Modal instance
createWeb3Modal({
    ethersConfig,
    chains: [bsc, bscTestnet, mainnet],
    projectId,
    enableAnalytics: false,
    themeMode: 'light'
})

export { projectId, bsc, bscTestnet }